import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./navbar";
import Footer from "./Footer";
import SharedHeroSection from "./SharedHeroSection";
import SectionHeading from "./SectionHeading";
import { blogPosts } from "./blogPosts";
import { ArrowRight, Clock3, Sparkles } from "lucide-react";

const featuredPost = blogPosts[0];

export default function BlogPage() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />

      <SharedHeroSection
        badge="Insights"
        badgeIcon={Sparkles}
        title={
          <>
            <span className="bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">Beyond Code</span><br/>The Orryworx Perspective
          </>
        }
        description="A closer look at AI, software product strategy, scalable engineering, and digital experiences built for real business impact."
        containerClassName="min-h-[60vh]"
      />

      <section className="bg-[#F8F8FB] py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <SectionHeading
              eyebrow="Latest Articles"
              title="Fresh thinking from our team"
              theme="light"
              titleClassName="text-[#111827]"
              descriptionClassName="hidden"
              showLine={false}
            />
          </div>

          <article className="group overflow-hidden rounded-[28px] border border-gray-200 bg-white shadow-sm hover:shadow-xl transition-all duration-300">
            <div className="grid lg:grid-cols-[1.2fr_0.8fr]">
              <div className="overflow-hidden">
                <div className="aspect-video w-full overflow-hidden">
                  <img
                    src={featuredPost.image}
                    alt={featuredPost.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>

              <div className="p-8 lg:p-10 flex flex-col justify-center">
                <span className="inline-flex w-fit rounded-full bg-[#EBF2FF] px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-[#355dff]">
                  {featuredPost.category}
                </span>

                <h2 className="mt-6 text-3xl font-extrabold leading-tight text-[#111827] md:text-4xl">
                  {featuredPost.title}
                </h2>

                <div className="mt-5 flex flex-wrap items-center gap-5 text-sm text-gray-500">
                  <span className="inline-flex items-center gap-2">
                    <Clock3 size={15} className="text-[#355dff]" />
                    {featuredPost.readTime}
                  </span>
                </div>

                <p className="mt-6 text-base leading-8 text-gray-600">
                  {featuredPost.excerpt}
                </p>

                <Link
                  to={`/blog/${featuredPost.id}`}
                  className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-[#355dff] px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-[#355dff]/20 transition hover:bg-blue-700"
                >
                  Read Article
                  <ArrowRight size={16} />
                </Link>
              </div>
            </div>
          </article>

          <div className="mt-16 grid gap-8 md:grid-cols-2 xl:grid-cols-3">
            {blogPosts.slice(1).map((post) => (
              <article
                key={post.id}
                className="group overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-sm hover:-translate-y-2 hover:shadow-xl transition-all duration-300"
              >
                <div className="overflow-hidden">
                  <div className="aspect-video w-full overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                </div>

                <div className="p-6">
                  <span className="inline-flex rounded-full bg-[#EBF2FF] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-[#355dff]">
                    {post.category}
                  </span>

                  <h3 className="mt-4 text-2xl font-bold leading-tight text-[#111827]">
                    {post.title}
                  </h3>

                  <div className="mt-4 flex items-center gap-4 text-xs text-gray-500">
                    <span className="inline-flex items-center gap-1.5">
                      <Clock3 size={14} className="text-[#355dff]" />
                      {post.readTime}
                    </span>
                  </div>

                  <p className="mt-4 text-sm leading-7 text-gray-600">
                    {post.excerpt}
                  </p>

                  <Link
                    to={`/blog/${post.id}`}
                    className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#355dff]"
                  >
                    Read more
                    <ArrowRight size={16} />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
